import udfLinks from './udfLinks';

export default udfLinks;
